import { I18nextProvider } from 'react-i18next';
var TekionI18nProvider = I18nextProvider;
export default TekionI18nProvider;